import React, { useEffect, useRef, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { apiListNotifications, apiReadNotification, apiReadAllNotifications } from "@/api";

const NotificationBell = () => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);

  const load = () => apiListNotifications().then((d) => { setItems(d.notifications || []); setUnread(d.unread || 0); }).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const markAll = async () => { await apiReadAllNotifications(); load(); };
  const onItem = async (n) => { if (!n.read) { await apiReadNotification(n.notif_id); load(); } };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notif-bell" onClick={() => { setOpen((o) => !o); if (!open) load(); }}
        className="relative flex h-10 w-10 items-center justify-center rounded-lg text-slate-600 transition-colors hover:bg-slate-100 hover:text-[#1B1F5B]">
        <Bell className="h-5 w-5" />
        {unread > 0 && (
          <span data-testid="notif-badge" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white">{unread > 9 ? "9+" : unread}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-dropdown" className="absolute right-0 z-50 mt-2 max-h-96 w-80 overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-xl">
          <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
            <p className="text-sm font-extrabold text-slate-800">Notifications</p>
            {unread > 0 && <button data-testid="notif-read-all" onClick={markAll} className="flex items-center gap-1 text-[11px] font-bold text-[#0E7C6B]"><CheckCheck className="h-3.5 w-3.5" /> Mark all read</button>}
          </div>
          <div className="max-h-80 overflow-y-auto">
            {items.length === 0 ? (
              <p className="py-10 text-center text-sm text-slate-400">No notifications yet.</p>
            ) : items.map((n) => (
              <button key={n.notif_id} data-testid={`notif-item-${n.notif_id}`} onClick={() => onItem(n)}
                className={`flex w-full flex-col items-start gap-0.5 border-b border-slate-50 px-4 py-3 text-left transition-colors hover:bg-slate-50 ${n.read ? "" : "bg-[#1B1F5B]/[0.03]"}`}>
                <div className="flex w-full items-center justify-between">
                  <p className="text-sm font-bold text-slate-800">{n.title}</p>
                  {!n.read && <span className="h-2 w-2 shrink-0 rounded-full bg-[#0E7C6B]" />}
                </div>
                {n.body && <p className="text-xs text-slate-500">{n.body}</p>}
                <p className="text-[10px] text-slate-400">{(n.created_at || "").slice(0, 16).replace("T", " ")}</p>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
